import { httpClient } from '@/shared/api/client.ts'
import { ReferralRequest, ReferralResponse } from '@/domains/auth/api/types'

export function registerReferral({ referralCode }: ReferralRequest) {
  return httpClient
    .post('member/referral', {
      json: {
        referralCode,
      },
    })
    .json<ReferralResponse>()
}
